import React from "react";

export const NidaLogo = ({ className = "h-7", showWordmark = true }) => (
    <div className={`flex items-center gap-2 ${className}`} aria-label="Nida Digital">
        <svg
            viewBox="0 0 40 40"
            className="h-full w-auto"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <defs>
                <linearGradient id="nidaG" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#0055FF" />
                    <stop offset="1" stopColor="#00E5FF" />
                </linearGradient>
            </defs>
            <path
                d="M8 32V8h4l16 16V8h4v24h-4L12 16v16H8z"
                fill="url(#nidaG)"
            />
            <circle cx="32" cy="8" r="2.5" fill="#00E5FF" />
        </svg>
        {showWordmark && (
            <span className="font-display text-lg font-semibold tracking-tight">
                Nida<span className="text-white/60"> Digital</span>
            </span>
        )}
    </div>
);

export default NidaLogo;
